function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    } else {
      const deferredElement = this.querySelector('video, model-viewer, iframe');
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;

    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.warehouseAvailability = null;
  }

  // Helper function to check if variant is available considering warehouse stock
  isVariantAvailable(variant) {
    if (!variant || !variant.available) return false;
    
    // Check warehouse availability if data is loaded
    if (this.warehouseAvailability) {
      const warehouseData = this.warehouseAvailability.find(w => w.variant_id === variant.id);
      if (warehouseData && !warehouseData.warehouse_available) {
        return false;
      }
    }
    
    return true;
  }

  // Load warehouse availability data
  getWarehouseAvailability() {
    if (this.warehouseAvailability) return this.warehouseAvailability;
    
    const warehouseScript = this.querySelector('[id^="warehouse-availability-"]');
    if (warehouseScript) {
      try {
        const data = JSON.parse(warehouseScript.textContent);
        this.warehouseAvailability = data.warehouse_availability || [];
      } catch (e) {
        console.error('Error parsing warehouse availability data:', e);
        this.warehouseAvailability = [];
      }
    }
    return this.warehouseAvailability;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.toggleBackOrderInfo();
    this.togglePreOrderInfo();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', false);
      this.setUnavailable();
      this.toggleBackOrderInfo();
      this.togglePreOrderInfo(false);
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    this.currentVariant = variantData.find((variant) => {
     
      if (variant.metafields && variant.metafields.custom && variant.metafields.custom.hide_from_online_pdp === true) {
        return false;
      }
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    this.getWarehouseAvailability(); // Load warehouse data
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => this.isVariantAvailable(variant) && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    this.getWarehouseAvailability(); // Load warehouse data
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.isVariantAvailable(this.currentVariant)) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        this.getWarehouseAvailability(); // Ensure warehouse data is loaded
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        // Check if variant is available considering warehouse stock
        const isAvailable = this.currentVariant && this.isVariantAvailable(this.currentVariant);
        this.toggleAddButton(
          addButtonUpdated ? (addButtonUpdated.hasAttribute('disabled') || !isAvailable) : !isAvailable,
          window.variantStrings.soldOut,
          true,
          true
        );

        const backorderInfoUpdated = html.getElementById(`BackOrderInfo-${sectionId}`);
        this.toggleBackOrderInfo(backorderInfoUpdated ? backorderInfoUpdated.classList.contains('visible') : false);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, soldOut = false) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      // Check for preorder conditions
      const buttonText = this.getButtonText();
      addButtonText.textContent = buttonText;
    }

    if (soldOut && disable) {
      addButton.classList.add('sold-out');
    } else {
      addButton.classList.remove('sold-out');
    }

    if (!modifyClass) return;
  }

  getButtonText() {
    if (!this.currentVariant) return window.variantStrings.addToCart;
    
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return window.variantStrings.addToCart;
    
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return window.variantStrings.addToCart;
    
    // Get preorder data
    const preorderDataScript = document.getElementById(`variant-preorder-data-${this.dataset.section}`);
    if (!preorderDataScript) return window.variantStrings.addToCart;
    
    try {
      const preorderData = JSON.parse(preorderDataScript.textContent);
      const variantData = preorderData.variants.find(v => v.id === this.currentVariant.id);
      
      if (variantData && variantData.preorder_message && 
          variantData.inventory_policy !== 'continue' && 
          variantData.inventory_quantity > 0) {
        return addButton.dataset.preorderText || 'Pre-Order Now';
      }
    } catch (e) {
      console.warn('Error parsing preorder data:', e);
    }
    
    return addButton.dataset.addToCartText || window.variantStrings.addToCart;
  }

  toggleBackOrderInfo(visible = false) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const backOrderInfo = productForm.querySelector('.backorder-info');

    if (!backOrderInfo) return;

    if (visible) {
      backOrderInfo.classList.add('visible');
    } else {
      backOrderInfo.classList.remove('visible');
    }
  }

  togglePreOrderInfo(visible = null) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const preorderInfo = productForm.querySelector('#BackOrderInfo-' + this.dataset.section + '.backorder-info--preorder');
    if (!preorderInfo) return;

    // If visible is explicitly set, use that value
    if (visible !== null) {
      if (visible) {
        preorderInfo.classList.add('visible');
      } else {
        preorderInfo.classList.remove('visible');
      }
      return;
    }

    // Otherwise, determine visibility based on current variant
    if (!this.currentVariant) {
      preorderInfo.classList.remove('visible');
      return;
    }

    // Get preorder data
    const preorderDataScript = document.getElementById(`variant-preorder-data-${this.dataset.section}`);
    if (!preorderDataScript) {
      preorderInfo.classList.remove('visible');
      return;
    }

    try {
      const preorderData = JSON.parse(preorderDataScript.textContent);
      const variantData = preorderData.variants.find(v => v.id === this.currentVariant.id);
      
      if (variantData && variantData.preorder_message && 
          variantData.inventory_policy !== 'continue' && 
          variantData.inventory_quantity > 0) {
        preorderInfo.classList.add('visible');
      } else {
        preorderInfo.classList.remove('visible');
      }
    } catch (e) {
      console.warn('Error parsing preorder data:', e);
      preorderInfo.classList.remove('visible');
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.getWarehouseAvailability(); // Load warehouse data when variant data is loaded

    this.variantData = this.variantData.filter(variant => {
      return !variant.metafields || !variant.metafields.custom || variant.metafields.custom.hide_from_online_pdp !== true;
    });
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const selectedOption = this.querySelector('.selected-option');
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    selectedOption.textContent = this.options[0];
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.list__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          // this.scrollbarMove();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class VideoContainer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('.play-button');

    if (this.video && this.playButton) {
      this.playButton.addEventListener('click', this.handlePlayButton.bind(this), false);

      this.video.addEventListener('pause', () => {
        this.playButton.classList.remove('playing');
      });

      this.video.addEventListener('play', () => {
        this.playButton.classList.add('playing');
      });
    }
  }

  async playVideo() {
    try {
      await this.video.play();
      this.playButton.classList.add('playing');
    } catch (err) {
      this.playButton.classList.remove('playing');
    }
  }

  handlePlayButton() {
    if (this.video.paused) {
      this.playVideo();
    } else {
      this.video.pause();
      this.playButton.classList.remove('playing');
    }
  }

  togglePlayButtonClassBasedOnVideoState() {
    if (this.video.paused) {
      this.playButton.classList.add('playing');
    } else {
      this.playButton.classList.remove('playing');
    }
  }
}

customElements.define('video-container', VideoContainer);

class SelectDropdown extends HTMLElement {
  constructor() {
    super();
    this.activeClass = 'opened';
    this.dropdownBtn = this.querySelector('.select-dropdown__button');
    this.dropdownMenu = this.querySelector('.select-dropdown__dropdown');
    this.closeDropdownMenuBtn = this.querySelector('.icon-close');
    this.options = this.querySelectorAll('input');

    this.addEventListener('click', (e) => {
      if (e.target.className === 'select-dropdown__overlay') {
        this.toggleDropdown();
      }
    });

    if (this.dropdownBtn && this.dropdownMenu) {
      this.dropdownBtn.addEventListener('click', this.toggleDropdown.bind(this));
    }

    if (this.closeDropdownMenuBtn) {
      this.closeDropdownMenuBtn.addEventListener('click', this.toggleDropdown.bind(this));
    }

    if (this.options) {
      Array.from(this.options).forEach((option) => option.addEventListener('change', this.toggleDropdown.bind(this)));
    }
  }

  toggleDropdown() {
    this.classList.toggle(this.activeClass);
  }
}

customElements.define('select-dropdown', SelectDropdown);

class CustomScrollBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.attachShadow({ mode: 'open' });

    this.targetElId = this.dataset.targetId;
    this.trackColor = this.dataset.trackColor || 'rgba(20, 29, 49, 0.20)';
    this.trackWidth = this.dataset.trackWidth || '100%';
    this.thumbColor = this.dataset.thumbColor || '#141D31';
    this.targetEl = document.querySelector(`#${this.targetElId}`);

    const style = document.createElement('style');
    style.textContent = `
      .custom-scrollbar {
        width: ${this.trackWidth};
        height: 0.3rem;
        position: absolute;
        bottom: 0;
        left: 0;
      }

      .custom-scrollbar__track {
        width: 100%;
        height: 100%;
        background-color: ${this.trackColor};
      }

      .custom-scrollbar__thumb {
        width: 0;
        height: 100%;
        background-color: ${this.thumbColor};
        border-radius: 0.3rem;
        position: absolute;
        top: 0;
        animation: top 0.25s ease-in;

      }

      .custom-scrollbar__thumb::hover {
        background-color: red;
      }
    `;
    this.shadowRoot.appendChild(style);

    // add css to document head
    const style2 = document.createElement('style');
    style2.textContent = `
      .prevent-scroll {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
    `;

    document.head.appendChild(style2);

    if (!this.targetEl) {
      console.warn(
        `CustomScrollBar: target element with id "${this.targetElId}" not found`,
        this,
        this.dataset.targetId
      );
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.setTargetElCSS();
          this.setScrollThumbWidth();
        }
      });
    });

    observer.observe(this.targetEl);

    this.shadowRoot.innerHTML += `
      <div class="custom-scrollbar">
        <div class="custom-scrollbar__track">
          <div class="custom-scrollbar__thumb"></div>
        </div>
      </div>
    `;

    this.targetEl.addEventListener('scroll', () => {
      this.moveScrollThumb();
    });

    window.addEventListener('resize', this.setScrollThumbWidth.bind(this));
  }

  moveScrollThumb() {
    const scrollBarThumb = this.shadowRoot.querySelector('.custom-scrollbar__thumb');
    const scrollBarTrackWidth = this.shadowRoot.querySelector('.custom-scrollbar__track').offsetWidth;
    const scrollThumbLeft = (this.targetEl.scrollLeft / this.targetEl.scrollWidth) * scrollBarTrackWidth;
    scrollBarThumb.style.left = `${scrollThumbLeft}px`;
  }

  setTargetElCSS() {
    this.targetEl.style.overflowX = 'scroll';
    this.targetEl.style.position = 'relative';
    this.targetEl.style['-ms-overflow-style'] = 'none'; /* Firefox */
    this.targetEl.style.scrollbarWidth = 'none'; /* Firefox */
  }

  setScrollThumbWidth() {
    // get the scroll bar element
    const scrollBarTrack = this.shadowRoot.querySelector('.custom-scrollbar__track');
    const scrollBarThumb = this.shadowRoot.querySelector('.custom-scrollbar__thumb');

    // get the scroll bar track width
    const scrollBarTrackWidth = scrollBarTrack.offsetWidth;

    // get the target element width
    const targetElWidth = this.targetEl.offsetWidth;

    // get the target element scroll width
    const targetElScrollWidth = this.targetEl.scrollWidth;

    // calculate the scroll thumb height
    const scrollThumbWidth = (targetElWidth / targetElScrollWidth) * scrollBarTrackWidth;

    // set the scroll thumb height
    scrollBarThumb.style.width = `${scrollThumbWidth}px`;

    // attach click-drag event on the thumb
    let isDragging = false;
    let currentX;
    scrollBarThumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      currentX = e.clientX;
      // prevent dragging hilights
      this.preventContentHighlight('remove');
    });
    document.addEventListener('mouseup', () => {
      isDragging = false;
      // remove prevent dragging highlights
      this.preventContentHighlight('add');
    });
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - currentX;
      currentX = e.clientX;

      this.targetEl.scrollLeft += deltaX * (targetElScrollWidth / scrollBarTrackWidth);

      console.log;
    });
  }

  // prevent content highlight when dragging the thumb
  preventContentHighlight(action) {
    if (action) {
      this.targetEl.classList.add('prevent-scroll');
    } else {
      this.targetEl.classList.add('prevent-scroll');
    }
  }
}

customElements.define('custom-scrollbar', CustomScrollBar);

class ProductGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.parser = new DOMParser();
    this.collectionWrapper = this.querySelector('.collection');
    this.productGridContainer = this.querySelector('.product-grid');
    this.loadMoreBtn = this.querySelector('#loadMore');
    this.nextUrl = this.getAttribute('data-next-url');
    this.loadingClass = 'loading';

    if (this.loadMoreBtn && this.nextUrl) {
      this.loadMoreBtn.addEventListener('click', this.getNextProducts.bind(this));
    }
  }

  async getNextProducts() {
    this.collectionWrapper.classList.add(this.loadingClass);

    try {
      const res = await fetch(this.nextUrl);

      if (res.ok) {
        const data = await res.text();
        const html = this.parser.parseFromString(data, 'text/html');
        const productGrid = html.querySelector('.product-grid');
        const loadMoreBtn = html.querySelector('#loadMore');
        this.nextUrl = html.querySelector('product-grid').getAttribute('data-next-url');

        if (!loadMoreBtn) {
          this.loadMoreBtn.remove();
        }

        Array.from(productGrid.children).forEach((productItem) => {
          this.productGridContainer.appendChild(productItem);
          if (this.nextUrl == ""){
            this.loadMoreBtn.remove();
          }
        });

        this.collectionWrapper.classList.remove(this.loadingClass);
      }
    } catch (e) {
      this.collectionWrapper.classList.remove(this.loadingClass);
      console.error(`Failed fetching next products`, e);
    }
  }
}

customElements.define('product-grid', ProductGrid);


const scrollTOAnkor = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          
          e.preventDefault();

        
          const targetId = this.getAttribute('href');
          
        
          const targetElement = document.querySelector(targetId);

          
          if (targetElement) {
              targetElement.scrollIntoView({
                  behavior: 'smooth', 
                  block: 'start'      
              });
          }
      });
  });
}
 document.addEventListener("DOMContentLoaded", (event) => {
  scrollTOAnkor()
  });




// ---- Featured gift cart: start ----
/*
 * Product + gift pairs added by sections/section-featured-new.liquid. Runs on every page, in the cart drawer
 * and on the cart page:
 * - quantity changes and removals in the cart are mirrored on the other line of the pair;
 * - a gift left without its product is removed (page load, re-renders, changes made elsewhere);
 * - product links on both lines and the gift's remove button are taken out;
 * - checkout is disabled while any of this is running.
 * Only window.featuredGiftCart is exposed; everything else stays inside this function.
 */
(() => {
  if (window.featuredGiftCart) return;

  // Both lines of a product + gift pair carry this hidden property: "<product variant id>:<gift variant id>".
  const LINK_PROPERTY = '_featured_bundle';

  function cartEndpoint(action) {
    const routes = window.routes || {};
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const route = action ? routes[`cart_${action}_url`] : routes.cart_url;
    return `${route || `${root}cart${action ? `/${action}` : ''}`}.js`;
  }

  async function postCart(action, body) {
    const response = await fetch(cartEndpoint(action), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return response.json();
  }

  async function fetchCart() {
    const response = await fetch(cartEndpoint(), { headers: { Accept: 'application/json' } });
    return response.json();
  }

  function emit(eventName, data) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS[eventName], data);
  }

  // Groups cart lines by pair: { lines, mainVariantId, giftVariantId, mainLine, giftLine } per bundle id.
  function getBundlePairs(items) {
    const pairs = new Map();
    (items || []).forEach((item) => {
      const bundleId = item.properties && item.properties[LINK_PROPERTY];
      if (!bundleId) return;
      if (!pairs.has(bundleId)) {
        const [mainVariantId, giftVariantId] = String(bundleId).split(':');
        pairs.set(bundleId, { lines: [], mainVariantId, giftVariantId });
      }
      pairs.get(bundleId).lines.push(item);
    });
    pairs.forEach((pair) => {
      pair.mainLine = pair.lines.find((line) => String(line.variant_id) !== pair.giftVariantId);
      pair.giftLine = pair.lines.find((line) => String(line.variant_id) === pair.giftVariantId);
    });
    return pairs;
  }

  /**
   * Returns { lineKey: quantity } updates that bring every product + gift pair back in line,
   * or null when nothing needs to change.
   */
  function getBundleUpdates(items, sourceVariantId, matchLowest) {
    const updates = {};
    getBundlePairs(items).forEach((pair) => {
      const { lines, mainLine, giftLine } = pair;

      // One half of the pair was removed, so the other half goes too.
      if (!mainLine || !giftLine) {
        lines.forEach((line) => {
          updates[line.key] = 0;
        });
        return;
      }

      const quantities = lines.map((line) => line.quantity);
      if (quantities.every((quantity) => quantity === quantities[0])) return;

      const sourceLine = lines.find((line) => String(line.variant_id) === String(sourceVariantId)) || mainLine;
      const target = matchLowest ? Math.min(...quantities) : sourceLine.quantity;
      lines.forEach((line) => {
        if (line.quantity !== target) updates[line.key] = target;
      });
    });

    return Object.keys(updates).length ? updates : null;
  }

  // Returns updates that remove gifts whose product is no longer in the cart, or null when there are none.
  function getOrphanGiftUpdates(items) {
    const updates = {};
    getBundlePairs(items).forEach((pair) => {
      if (pair.mainLine) return;
      pair.lines.forEach((line) => {
        updates[line.key] = 0;
      });
    });
    return Object.keys(updates).length ? updates : null;
  }

  // Reuses the theme's own cart components so the drawer and the cart page re-render the way they normally do.
  function getCartRenderTargets() {
    const targets = [];
    const seen = new Set();
    document.querySelectorAll('cart-drawer-items, cart-items').forEach((element) => {
      if (typeof element.getSectionsToRender !== 'function') return;
      let sections = [];
      try {
        sections = element.getSectionsToRender();
      } catch (error) {
        return;
      }
      sections.forEach((section) => {
        if (seen.has(section.section)) return;
        seen.add(section.section);
        targets.push(section);
      });
    });
    // The Cart API renders at most 5 sections per request.
    return targets.slice(0, 5);
  }

  function renderCartSections(state, targets) {
    targets.forEach((target) => {
      const html = state.sections && state.sections[target.section];
      const host = document.getElementById(target.id);
      if (!html || !host) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(target.selector);
      if (!source) return;
      (host.querySelector(target.selector) || host).innerHTML = source.innerHTML;
    });

    const isEmpty = state.item_count === 0;
    document
      .querySelectorAll('cart-drawer, cart-drawer-items, cart-items, #main-cart-footer')
      .forEach((element) => element.classList.toggle('is-empty', isEmpty));

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active') || typeof trapFocus !== 'function') return;
    const emptyState = drawer.querySelector('.drawer__inner-empty');
    if (isEmpty && emptyState) {
      trapFocus(emptyState, drawer.querySelector('a'));
    } else {
      trapFocus(drawer, drawer.querySelector('.cart-item__name') || drawer.querySelector('.drawer__close'));
    }
  }

  function setCartLoading(isLoading) {
    document
      .querySelectorAll('#CartDrawer-CartItems, #main-cart-items')
      .forEach((element) => element.classList.toggle('cart__items--disabled', isLoading));
  }

  function showCartError(message) {
    const errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (errors) errors.textContent = message || (window.cartStrings && window.cartStrings.error) || '';
  }

  function onDocumentReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  const CHECKOUT_SELECTOR = '#CartDrawer-Checkout, #checkout';
  const EXPRESS_CHECKOUT_SELECTOR = '.cart__dynamic-checkout-buttons';
  // The theme adds this class to the cart items while its own quantity request is running.
  const CART_BUSY_SELECTOR = '#CartDrawer-CartItems.cart__items--disabled, #main-cart-items.cart__items--disabled';

  /**
   * Disables checkout while the cart is changing or being re-checked, so nobody reaches checkout with a gift
   * whose product is about to be removed. Holds come from this script; the theme's busy class counts too.
   */
  class FeaturedNewCheckoutLock {
    constructor() {
      this.holds = new Set();
      this.observer = new MutationObserver(() => this.update());
      onDocumentReady(() => {
        // Watches for the theme's busy class and for re-rendered checkout buttons that need locking again.
        document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer').forEach((element) => {
          this.observer.observe(element, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
        });
        this.update();
      });
    }

    hold(reason) {
      this.holds.add(reason);
      this.update();
    }

    release(reason) {
      this.holds.delete(reason);
      this.update();
    }

    update() {
      const isLocked = this.holds.size > 0 || Boolean(document.querySelector(CART_BUSY_SELECTOR));

      document.querySelectorAll(CHECKOUT_SELECTOR).forEach((button) => {
        // Buttons the theme disabled itself (an empty cart) are left alone.
        if (isLocked && !button.disabled) {
          button.disabled = true;
          button.setAttribute('data-featured-new-locked', '');
        } else if (!isLocked && button.hasAttribute('data-featured-new-locked')) {
          button.disabled = false;
          button.removeAttribute('data-featured-new-locked');
        }
      });

      // Express checkout buttons are iframes that can't be disabled, so the whole block is made inert.
      document.querySelectorAll(EXPRESS_CHECKOUT_SELECTOR).forEach((container) => {
        container.inert = isLocked;
        container.style.opacity = isLocked ? '0.5' : '';
      });
    }
  }

  function holdCheckout(reason, isHeld) {
    if (isHeld) {
      checkoutLock.hold(reason);
    } else {
      checkoutLock.release(reason);
    }
  }

  /**
   * Keeps product + gift pairs together in the cart. The theme's cart items publish a "cart-items"
   * cartUpdate after every quantity change or removal; this then updates or removes the other half.
   */
  class FeaturedNewCartSync {
    constructor() {
      this.pending = null;
      this.running = false;
      this.publishing = false;
      if (!this.listen()) document.addEventListener('DOMContentLoaded', () => this.listen(), { once: true });
    }

    listen() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
      return true;
    }

    onCartUpdate(event) {
      if (this.publishing || !event || event.source !== 'cart-items') return;
      // A change that lands mid-sync may carry a stale cart, so that one re-reads the cart instead.
      this.queue({ type: 'sync', variantId: event.variantId, cart: this.running ? null : event.cartData });
    }

    // Removes gifts whose product is gone. It always re-reads the cart first, so a stale copy never removes a gift.
    check() {
      this.queue({ type: 'check', cart: null });
    }

    queue(job) {
      // A sync also removes gifts left without their product, so a waiting sync is never swapped for a check.
      if (!this.pending || this.pending.type !== 'sync' || job.type === 'sync') this.pending = job;
      holdCheckout('sync', true);
      if (this.running) return;
      this.running = true;
      // Wait for the theme's own request to finish its cleanup before taking over the cart UI.
      setTimeout(() => this.run());
    }

    async run() {
      try {
        while (this.pending) {
          const job = this.pending;
          this.pending = null;
          const cart = isFullCart(job.cart) ? job.cart : await fetchCart();
          await this.reconcile(cart, job);
        }
      } catch (error) {
        console.error(error);
        showCartError();
      } finally {
        this.running = false;
        setCartLoading(false);
        holdCheckout('sync', false);
      }
    }

    async reconcile(cart, job) {
      const updates =
        job.type === 'sync' ? getBundleUpdates(cart.items, job.variantId, false) : getOrphanGiftUpdates(cart.items);
      if (!updates) return;

      setCartLoading(true);
      const targets = getCartRenderTargets();
      const update = async (lineUpdates) => {
        const state = await postCart('update', {
          updates: lineUpdates,
          sections: targets.map((target) => target.section),
          sections_url: window.location.pathname,
        });
        if (state.status) throw new Error(state.description || state.message);
        return state;
      };

      let state = await update(updates);
      // Shopify caps a line at the stock it has; if that split the pair, both drop to the lower quantity.
      const capped = job.type === 'sync' && getBundleUpdates(state.items, null, true);
      if (capped) state = await update(capped);

      renderCartSections(state, targets);

      this.publishing = true;
      try {
        emit('cartUpdate', { source: 'cart-items', cartData: state });
      } finally {
        this.publishing = false;
      }
    }
  }

  const checkoutLock = new FeaturedNewCheckoutLock();
  const cartSync = new FeaturedNewCartSync();

  const CART_ROW_SELECTOR = '.cart-item[id^="CartDrawer-Item-"], .cart-item[id^="CartItem-"]';

  function isFullCart(cart) {
    return Boolean(cart) && Array.isArray(cart.items) && typeof cart.item_count === 'number';
  }

  function unlinkCartRow(row) {
    row.querySelectorAll('a.cart-item__link').forEach((link) => link.remove());
    row.querySelectorAll('a.cart-item__name').forEach((link) => {
      const title = document.createElement('span');
      Array.from(link.attributes).forEach((attribute) => {
        if (attribute.name !== 'href') title.setAttribute(attribute.name, attribute.value);
      });
      // The theme moves focus to .cart-item__name after cart updates, so the title stays focusable from script.
      title.setAttribute('tabindex', '-1');
      title.append(...link.childNodes);
      link.replaceWith(title);
    });
  }

  function hideRemoveButton(row) {
    row.querySelectorAll('cart-remove-button').forEach((button) => {
      button.hidden = true;
      // The theme gives cart-remove-button its own display value, which would override the hidden attribute.
      button.style.setProperty('display', 'none', 'important');
    });
  }

  /**
   * Turns the product links on product + gift lines into plain text and hides the gift's remove button,
   * in the cart drawer and on the cart page.
   * Cart rows don't print line item properties, so each row is matched to the cart JSON by its line number.
   */
  class FeaturedNewCartLinks {
    constructor() {
      this.cart = null;
      this.timer = null;
      this.requestId = 0;
      this.observer = new MutationObserver(() => this.schedule());
      onDocumentReady(() => this.init());
    }

    init() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && isFullCart(event.cartData)) this.cart = event.cartData;
        });
      }
      // Both elements stay on the page while the theme swaps the cart markup inside them.
      document.querySelectorAll('cart-drawer, cart-items').forEach((element) => {
        this.observer.observe(element, { childList: true, subtree: true });
      });
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.refresh(), 50);
    }

    async refresh() {
      if (!document.querySelector(CART_ROW_SELECTOR)) return;
      if (this.cart && this.apply(this.cart)) {
        this.checkOrphanGifts(this.cart);
        return;
      }

      // Checkout stays locked until the re-rendered cart has been read and checked.
      const requestId = ++this.requestId;
      holdCheckout('links', true);
      try {
        const cart = await fetchCart();
        if (requestId !== this.requestId) return;
        this.cart = cart;
        this.apply(cart);
        this.checkOrphanGifts(cart);
      } catch (error) {
        console.error(error);
      } finally {
        if (requestId === this.requestId) holdCheckout('links', false);
      }
    }

    // Covers gifts left alone by anything other than the theme's cart buttons: page load, apps, other tabs.
    checkOrphanGifts(cart) {
      if (getOrphanGiftUpdates(cart.items)) cartSync.check();
    }

    // Leaves the page untouched and returns false when the rendered rows don't match this cart.
    apply(cart) {
      const rows = Array.from(document.querySelectorAll(CART_ROW_SELECTOR)).map((row) => ({
        row,
        item: cart.items[Number(row.id.split('-').pop()) - 1],
      }));

      const inSync = rows.every(({ row, item }) => {
        const input = row.querySelector('[data-quantity-variant-id]');
        return (
          Boolean(item && input) &&
          input.dataset.quantityVariantId === String(item.variant_id) &&
          Number(input.getAttribute('value')) === item.quantity
        );
      });
      if (!inSync) return false;

      const pairs = getBundlePairs(cart.items);
      rows.forEach(({ row, item }) => {
        const pair = pairs.get(item.properties && item.properties[LINK_PROPERTY]);
        if (!pair) return;
        unlinkCartRow(row);
        if (String(item.variant_id) === pair.giftVariantId) hideRemoveButton(row);
      });
      // Drop the mutations made above so they don't schedule another pass.
      this.observer.takeRecords();
      return true;
    }
  }

  const cartLinks = new FeaturedNewCartLinks();

  window.featuredGiftCart = {
    // The section adds these properties to both lines so the code above can find the pair again.
    bundleProperties: (mainVariantId, giftVariantId) => ({ [LINK_PROPERTY]: `${mainVariantId}:${giftVariantId}` }),
    checkoutLock,
    sync: cartSync,
    links: cartLinks,
  };
})();
// ---- Featured gift cart: end ----
